<template>
    <div id="RecallAssetMapper">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                        <div class="page-title"> Recall Asset Mapper List</div>                
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content recall-asset-lists">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container add-user-form-title form-custom-select" id="recallAssetMapperForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col-md-6 form-group">
                                        <label class="control-label" for="recall">Recall:</label>
                                        <v-select v-model="recall" name="recall" id="recall" label="text" :filterable="false" :options="recallArr" @input="recallAssetMapperSearch" @search="onSearchRecall" placeholder="Select Recall" class='custom-ci-auto-search'>
                                            <template slot="no-options">
                                                Search Recall...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                            </form>    
                        </section>      
                        <hr class="light-hr"/>                                            
                        <section class="mt-4 bg-white radius-5 p-3">
                            <template v-if="recallAssetMapperArr.length == 0">
                                <h4>No Recall Asset Mapper Found</h4>
                            </template>
                            <template v-else>
                                <div class="table-responsive-sm">
                                    <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm font-1" v-if="recallAssetMapperArr != undefined && recallAssetMapperArr.length > 0">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>Unit</th>
                                                <th>Name</th>
                                                <th>Vin</th>
                                                <th>Asset Type</th>
                                                <th>Recall Status</th>
                                                <th class="text-center">Action</th>
                                            </tr>    
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in recallAssetMapperArr" v-bind:key="index">
                                                <td>{{item.unit_no}}</td>
                                                <td>{{item.name}}</td>
                                                <td>{{item.vin}}</td>
                                                <td>{{item.asset_type}}</td>
                                                <td>{{item.recall_status}}</td>
                                                <td v-if="showRemoveRecallMapperBtn" class="text-center">
                                                    <i class="fp-close color-red close-icon cursor-pointer" v-on:click="removeRecallAssetMapper($event,item.id)"> </i>
                                                    <!-- <button class="btn" v-on:click="removeRecallAssetMapper($event,item.id)"> <i class="hi-icon icon-flclose1"> </i></button> -->
                                                </td>
                                                <td v-else class="text-center">
                                                    -
                                                </td>
                                            </tr>    
                                        </tbody>    
                                    </table> 
                                </div>   
                            </template>    
                        </section>            
                    </div>        
                </div>    
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>    
        </div>    
    </div>    
</template>
<script>
import Vue from "vue";

import {
    commonMixins
} from "../mixins/commonMixins";
export default {
    name: "RecallAssetMapper",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Recall Asset Mapper List | " +process.env.COPYRIGHT_NAME
    },
    
    mixins: [commonMixins],
    data: () => ({
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        loading: false,
        recall: null,
        recallArr:[],
        recallAssetMapperArr:[],
        showRemoveRecallMapperBtn:false
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == "view_recall_asset_mapper") {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == "delete_recall_asset_mapper") {
                        self.showRemoveRecallMapperBtn = true;
                    }                    
                }
            }
        },        
    },
    beforeMount() {
        var self = this;
    },
    created: function () {},
    mounted: function () {
        var self = this;
        self.getPermissions();
        var webloc = window.location.href;

        var decodeStr = "";
        if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {
            
            decodeStr = atob(this.$route.query.data)            

            var url = new URL(webloc+"?"+decodeStr);
            var recallValue = url.searchParams.get("recallValue");
            var recallText = url.searchParams.get("recallText");        
           self.recall = {text:recallText,value:recallValue};
           if(self.recall != null){
               self.recallAssetMapperSearch();
           }
        }         

    },
    methods: {        

        onSearchRecall(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'recall', '');
            }
        },

        recallAssetMapperSearch() {
            var self = this;
            if(self.recall == null || self.recall === ""){
                self.recallAssetMapperArr = [];
                return;
            }
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/recall-asset-mapper/search",
                type: "POST",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType:"json",
                data:{
                    recall:self.recall.value,
                },
                success: function (data) {
                    // console.log(data);
                    self.loading = false;
                    if ( data.status == "success") {
                        self.recallAssetMapperArr = data.content;
                    }                 
                    
                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR,true,'recall-asset-mapper-search');
                }
            });
        },
        removeRecallAssetMapper(index,mapperId) {
            var self = this;

            if (confirm('Are you sure that you want to remove this asset?')) {

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/recall-asset-mapper/delete",
                    type: "POST",
                    data: {
                        id : mapperId
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.recallAssetMapperSearch();
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'recall-asset-mapper-delete');
                    },
                });
            }
            
        }

    }    
    
}
</script>




// WEBPACK FOOTER //
// src/components/RecallAssetMapper.vue